import { mapSearchQuery, generatePath } from 'utils/url';

export const ROOT_PATH = '/';
export const NOT_FOUND_PATH = '/404';
export const ABOUT_PATH = '/:siteSlug?/about';
export const JOIN_PATH = '/join';
export const SUPPORTING_CHARITIES_PATH = '/:siteSlug?/supporting-charities';
export const VOLUNTEER_CONTENT_PATH = '/volunteer-content';
export const PARTNERSHIP_AND_LICENSING_PATH = '/:siteSlug?/partnership-and-licensing';
export const SITE_PATH = '/:siteSlug?';
export const EXPERT_PATH = '/:siteSlug/e/:expertSlug';
export const VERBOSE_EXPERT_PATH = '/:siteSlug/experts/:expertSlug';
export const FAQ_PATH = '/:siteSlug?/faq';
export const JOIN_AS_EXPERT_PATH = '/join-as-expert';
export const SEARCH_PATH = '/:siteSlug/search';
export const TERM_OF_SERVICE_PATH = '/:siteSlug?/terms';
export const SIGN_UP_PATH = '/:siteSlug?/sign-up';
export const SIGN_IN_PATH = '/:siteSlug?/sign-in';
export const GIFT_CARD_SITE_PATH = '/:siteSlug/gift-cards/new';
export const GIFT_CARD_SUCCESS_PATH = '/:siteSlug/gift-cards/success';
export const GIFT_CARD_CANCEL_PATH = '/:siteSlug/gift-cards/cancel';
export const GIFT_CARD_CANCEL = '/:siteSlug/gift-cards/cancel';
export const GIFT_CARD_REDEEM_PATH = '/:siteSlug/gift-cards/redeem';
export const USER_ACCOUNT_SETTINGS_PATH = '/:siteSlug?/account/general-settings';
export const EXPERT_ACCOUNT_SETTINGS_PATH = '/:siteSlug/account/expert-settings';
export const CALLS_DASHBOARD_PATH = '/:siteSlug/calls';
export const CALENDAR_CONNECTION_CALLBACK_PATH = '/:siteSlug/calendar-connections/:type/callback';
export const EXPERT_SIGN_UP_PATH = '/:siteSlug/expert-sign-up';
export const CONFIRMATION_SIGN_UP_PATH = '/:siteSlug?/sign-up/confirm';
export const FORGOT_PASSWORD_PATH = '/user/forgot-password';
export const RESEND_CONFIRMATION_PATH = '/user/resend-confirmation';
export const RESET_PASSWORD_PATH = '/user/reset-password';
export const CALL_REQUEST_PATH = '/:siteSlug/e/:expertSlug/:callSlug/:actionSlug';
export const VERBOSE_CALL_REQUEST_PATH = '/:siteSlug/experts/:expertSlug/:callSlug/:actionSlug';
export const SITE_INVITATION_PATH = '/:siteSlug/invitation';
export const FEEDBACK_FOR_SITE_PATH = '/:siteSlug?/give-feedback';
export const ZOOM_CONNECTION_CALLBACK_PATH = '/:siteSlug/zoom-connection/callback';
export const SIGN_IN_WITH_TOKEN_PATH = '/:siteSlug?/users/sign-in-with-token';
export const MFA_REVOCATION_PATH = '/:siteSlug?/users/mfa/revoke';
export const ONBOARDING_PATH = '/:siteSlug/onboarding';
export const PENDING_EXPERT_APPROVAL_PATH = '/:siteSlug/pending-expert-approval';
export const DOWNLOAD_APP_PATH = '/:siteSlug?/download-app';
export const CALL_REQUEST_INTERACTION_CALLBACK = '/:siteSlug/call-request-interaction-callback';
export const USER_ACCOUNT_SETTINGS_CALLBACK_PATH = '/:siteSlug?/account/general-settings/callback/:action';
export const USER_CREDIT_TRANSACTION_CALLBACK = '/:siteSlug/user-credit-transaction-callback';
export const SESSIONS_SEARCH_PAGE_PATH = '/:siteSlug/sessions-search';
export const JOIN_SESSION_PATH = '/:siteSlug/sessions/:callRequestSlug/join';
export const EVENTS_PATH = '/:siteSlug?/events';
export const EVENT_DETAILS_PATH = '/:siteSlug?/events/:eventSlug';
export const MEMBER_PATH = '/:siteSlug?/members/:memberSlug';
export const ORGANIZATIONS_SEARCH_PATH = '/:siteSlug?/organizations';
export const ORGANIZATION_PATH = '/:siteSlug?/organizations/:organizationSlug';
export const FUNDRAISER_PUBLIC_PAGE_PATH = '/:siteSlug?/users/:username/fundraisers/:fundraiserSlug';
export const DONATION_PATH = '/:siteSlug?/users/:username/fundraisers/:fundraiserSlug/donate';
export const DONATION_PROCESS_PAYMENT_PATH =
  '/:siteSlug?/users/:username/fundraisers/:fundraiserSlug/donations/process-payment';
export const DONATION_SUCCESS_PATH =
  '/:siteSlug?/users/:username/fundraisers/:fundraiserSlug/donations/:donationId/thanks';
export const DONATION_CANCEL_PATH = '/:siteSlug?/users/:username/fundraisers/:fundraiserSlug/donations/cancel';

export const buildChildSitePath = (siteSlug) => generatePath(SITE_PATH, { siteSlug });

export const buildExpertProfilePath = (siteSlug, expertSlug) => generatePath(EXPERT_PATH, { siteSlug, expertSlug });

export const buildSearchPath = (siteSlug, query = {}) =>
  `${generatePath(SEARCH_PATH, { siteSlug })}?${new URLSearchParams(mapSearchQuery(query)).toString()}`;

export const buildAboutPath = (siteSlug) => generatePath(ABOUT_PATH, { siteSlug });

export const buildTermsOfServicePath = (siteSlug) => generatePath(TERM_OF_SERVICE_PATH, { siteSlug });

export const buildFAQPath = (siteSlug) => generatePath(FAQ_PATH, { siteSlug });

export const buildCallDashboardPath = (siteSlug) => generatePath(CALLS_DASHBOARD_PATH, { siteSlug });

export const buildGiftCardSitePath = (siteSlug) => generatePath(GIFT_CARD_SITE_PATH, { siteSlug });

export const buildGiftCardSuccessUrl = (siteSlug, redirectLink) =>
  `${window.location.origin}${generatePath(GIFT_CARD_SUCCESS_PATH, { siteSlug })}?redirectTo=${redirectLink}`;

export const buildGiftCardCancelUrl = (siteSlug, redirectLink) =>
  `${window.location.origin}${generatePath(GIFT_CARD_CANCEL_PATH, { siteSlug })}?redirectTo=${redirectLink}`;

export const buildRedeemGiftCardPath = (siteSlug) => generatePath(GIFT_CARD_REDEEM_PATH, { siteSlug });

export const buildUserAccountSectionPath = (sectionHref, siteSlug) =>
  `${generatePath(USER_ACCOUNT_SETTINGS_PATH, { siteSlug })}${sectionHref}`;

export const buildExpertAccountSectionPath = (sectionHref, siteSlug) =>
  `${generatePath(EXPERT_ACCOUNT_SETTINGS_PATH, { siteSlug })}${sectionHref}`;

export const buildCallsDashboardSectionPath = (sectionHref, siteSlug) =>
  `${buildCallDashboardPath(siteSlug)}${sectionHref}`;

export const buildSiteInvitationPath = (siteSlug) => generatePath(SITE_INVITATION_PATH, { siteSlug });

export const buildExpertSignUpPath = (siteSlug) => generatePath(EXPERT_SIGN_UP_PATH, { siteSlug });

export const buildFeedbackForSitePath = (siteSlug) => generatePath(FEEDBACK_FOR_SITE_PATH, { siteSlug });

export const buildSignInPath = (siteSlug) => generatePath(SIGN_IN_PATH, { siteSlug });

export const buildOnboardingPath = (siteSlug) => generatePath(ONBOARDING_PATH, { siteSlug });

export const buildSitePendingExpertApprovalPath = (siteSlug) =>
  generatePath(PENDING_EXPERT_APPROVAL_PATH, { siteSlug });

export const buildDownloadAppPath = (siteSlug) => generatePath(DOWNLOAD_APP_PATH, { siteSlug });

export const buildPartnershipAndLicensingPath = (siteSlug) =>
  generatePath(PARTNERSHIP_AND_LICENSING_PATH, { siteSlug });

export const buildSupportingCharitiesPath = (siteSlug) => generatePath(SUPPORTING_CHARITIES_PATH, { siteSlug });

export const buildAcrossSiteLink = (rootDomain, opts = {}) => {
  const { token, siteSlug, redirectTo } = opts;

  const params = new URLSearchParams();

  if (token) params.append('token', token);
  if (redirectTo) params.append('redirectTo', redirectTo);

  return `https://${rootDomain}${generatePath(SIGN_IN_WITH_TOKEN_PATH, { siteSlug })}?${params.toString()}`;
};

export const buildSignUpPath = (siteSlug) => generatePath(SIGN_UP_PATH, { siteSlug });

export const buildSessionsSearchPath = (siteSlug, query = {}) =>
  `${generatePath(SESSIONS_SEARCH_PAGE_PATH, { siteSlug })}?${new URLSearchParams(mapSearchQuery(query)).toString()}`;

export const buildExpertProfileUrl = (siteSlug, expertSlug) =>
  `${window.location.origin}${buildExpertProfilePath(siteSlug, expertSlug)}`;

export const buildJoinSessionPath = (siteSlug, callRequestSlug) =>
  generatePath(JOIN_SESSION_PATH, { siteSlug, callRequestSlug });

export const buildSiteEventsPath = (siteSlug) => generatePath(EVENTS_PATH, { siteSlug });
export const buildEventDetailsPath = (siteSlug, eventSlug) => generatePath(EVENT_DETAILS_PATH, { siteSlug, eventSlug });

export const buildMemberPath = (siteSlug, memberSlug) => generatePath(MEMBER_PATH, { siteSlug, memberSlug });

export const buildOrganizationsSearchPath = (siteSlug, query = {}) =>
  `${generatePath(ORGANIZATIONS_SEARCH_PATH, { siteSlug })}?${new URLSearchParams(mapSearchQuery(query)).toString()}`;

export const buildOrganizationPath = (siteSlug, organizationSlug) =>
  generatePath(ORGANIZATION_PATH, { siteSlug, organizationSlug });

export const buildFundraiserPublicPagePath = (username, fundraiserSlug, siteSlug) =>
  generatePath(FUNDRAISER_PUBLIC_PAGE_PATH, { username, fundraiserSlug, siteSlug });

export const buildDonationPath = (username, fundraiserSlug, siteSlug) =>
  generatePath(DONATION_PATH, { username, fundraiserSlug, siteSlug });

export const buildDonationProcessPaymentUrl = (username, fundraiserSlug, siteSlug) =>
  generatePath(DONATION_PROCESS_PAYMENT_PATH, { username, fundraiserSlug, siteSlug });

export const buildDonationSuccessUrl = (username, fundraiserSlug, donationId, siteSlug) =>
  generatePath(DONATION_SUCCESS_PATH, { username, fundraiserSlug, donationId, siteSlug });

export const buildDonationCancelUrl = (username, fundraiserSlug, siteSlug) =>
  generatePath(DONATION_CANCEL_PATH, { username, fundraiserSlug, siteSlug });

export const buildFundraiserPagePath = (username, fundraiserSlug, siteSlug) =>
  generatePath(FUNDRAISER_PUBLIC_PAGE_PATH, { username, fundraiserSlug, siteSlug });
